$(window).load(function() {
	if (IS_QLIK_PAGE) {
		var script = document.createElement('script');
		script.onload = function() {
			var qlikScript = document.createElement('script');
			qlikScript.src =  ASSETS_PREFIX + 'js/script-qlik.js';
			document.body.append(qlikScript);
		};
		script.src = ASSETS_PREFIX + 'js/libs/require.js';
		document.body.append(script);
	}
});
